module.exports = __webpack_public_path__ + "img/none-data.5e468eb0.png";